import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=4f70fe6f&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=4f70fe6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f70fe6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f70fe6f')) {
      api.createRecord('4f70fe6f', component.options)
    } else {
      api.reload('4f70fe6f', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=4f70fe6f&scoped=true&", function () {
      api.rerender('4f70fe6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ShoSjoGPhL8q/JS/comp/Voucher.vue"
export default component.exports